module.exports = __webpack_public_path__ + "static/contact-static-8e1142431602228a4f5b2dc8ee937718.jpg";